'use client';

import { createClient } from '@/lib/supabase/client';

interface PartnershipInquiryData {
  organizationName: string;
  organizationType: string;
  contactName: string;
  email: string;
  phone: string;
  website?: string;
  partnershipType: string;
  collaborationInterests: string[];
  description: string;
  goals: string;
}

function isSchemaError(error: any): boolean {
  if (!error) return false;
  
  if (error.code && typeof error.code === 'string') {
    const errorClass = error.code.substring(0, 2);
    if (errorClass === '42' || errorClass === '08') {
      return true;
    }
    if (errorClass === '23') {
      return false;
    }
  }
  
  if (error.message) {
    const schemaErrorPatterns = [
      /relation.*does not exist/i,
      /column.*does not exist/i,
      /function.*does not exist/i,
      /syntax error/i,
      /invalid.*syntax/i,
      /type.*does not exist/i,
      /undefined.*column/i,
      /undefined.*table/i,
    ];
    return schemaErrorPatterns.some(pattern => pattern.test(error.message));
  }
  
  return false;
}

export const partnershipService = {
  async submitInquiry(data: PartnershipInquiryData) {
    const supabase = createClient();

    try {
      const { data: result, error } = await supabase
        .from('partnership_inquiries')
        .insert({
          organization_name: data.organizationName,
          organization_type: data.organizationType,
          contact_name: data.contactName,
          email: data.email,
          phone: data.phone,
          website: data.website || null,
          partnership_type: data.partnershipType,
          collaboration_interests: data.collaborationInterests,
          description: data.description,
          goals: data.goals,
        })
        .select()
        .single();

      if (error) {
        if (isSchemaError(error)) {
          console.error('Schema error:', error.message);
          throw error;
        } else {
          console.log('Data error:', error.message);
          return null;
        }
      }

      return result;
    } catch (error: any) {
      console.log('Schema-related error:', error.message);
      throw error;
    }
  },
};